import { computed, defineComponent, onMounted } from 'vue'
import { FORM_PROPS, type GeneralFormProps } from './types'
import { useForm } from './formv2/hooks/useForm'
import SubForm from './subform'
import CodeBlock from '../code-block'
import { jsonStringify } from '@/utils/json'

export const Form = defineComponent<GeneralFormProps<any>>({
  setup(props) {
    const handler = props.handler || useForm<any>(props as any)

    onMounted(() => {
      handler.init(handler);
    })

    const isDebug = computed(() => !!handler.props.debug)

    return () => {
      return (
        <div>
          <SubForm
            handler={handler}
            fields={handler.fields.value}
            schema={handler.schema}
            initialState={handler.initialState}
            onStateChange={handler.props.onStateChange}
            reportChange={handler.reportChange}
            triggerBlur={handler.triggerBlur}
            outputState={handler.props.outputState}
            outputStates={handler.props.outputStates}
            outputStats={handler.props.outputStats}
            debug={handler.props.debug}
            evaluatedState={handler.evaluatedState.value}
            componentExtensions={handler.props.componentExtensions}
          />
          {isDebug.value && (
            <div
              style={{
                height: '300px'
              }}
            >
              <CodeBlock
                resizable
                class="text-xs"
                value={jsonStringify(
                  {
                    //stats: unwrapNestedRefs(handler.stats.state),
                    state: handler.state,
                  //  errors: unwrapNestedRefs(handler.errors.state),
                  },
                  2
                )}
              />
            </div>
          )}
        </div>
      )
    }
  }
})
Form.props = [...FORM_PROPS, 'handler', 'schema']
